import { useContext, useEffect, useState } from 'react';
import Checkbox from '../../../../components/Checkbox/Checkbox';
import Input from '../../../../components/Inputs/Input';
import './GeneralSectionForm.css';
import Select, { Option } from '../../../../components/Inputs/Select';
import coloredWarningImage from '../../../../assets/Icons/colored-warning.svg';

import { createPart, getDropdownConfiguration, getPartInfo } from '../../services/PartsConfigurationService';
import { Dropdowns } from '../../../../components/Dropdowns/Dropdowns';
import CheckboxField from '../../../../components/Checkbox/CheckboxField';
import MultioptionButton from '../../../../components/Buttons/MultioptionButton';
import { PartConfigurationContext } from '../../contexts/PartConfigurationContext';
import { useSnackBar } from '../../../../hooks/useSnackBar';
import { DropdownsContext } from '../../../../contexts/DropdownsContext';
import { usePermissions } from '../../../../hooks/usePermissions';
import { localStorageGet, localStorageSave } from '../../../../services/localStorageService';
import { useDispatch, useSelector } from 'react-redux';
import { closeDraft, selectNewParts } from '../../../../redux/features/configuration/parts/partsConfigurationSlice';

// const dropdownIds = [4, 5, 6, 7];
const ATADropdowns = [8, 9, 10];
const otherDropdowns = [4, 5, 6, 7];
const requiredDropdowns = [4, 5, 7, 6];
const dropdownNames = { 4: 'categoryId', 5: 'subCategoryId', 6: 'dimensionUomId', 7: 'manufacturerId', 8: "atachapterId", 9: "atasectionId", 10: "ataparagraphId" };
const requiredFields = {
  ...Object.fromEntries(requiredDropdowns.map(id => [dropdownNames[id], true])),
  "partNumber": true,
  "name": true,
  "description": true,
}

const defaultEmptyValues = {
  name: "",
  partNumber: "",
  description: "",
  categoryId: null,
  subCategoryId: null,
  atachapterId: null,
  atasectionId: null,
  ataparagraphId: null,
  pmaStatus: false,
  receivingInpsection: false,
  dimensionUomId: "",
  hazardousMaterial: false,
  manufacturerId: null,
  partType: " "
};
const hideFieldsWhenDisabled = new Set(["categoryId", "subCategoryId", "ATAChapter", "ATASection", "ATAParagraph"]);
const localStoragePrefix = 'configuration/parts/general';
const fieldChangeMapper = {
  categoryId: (completeValue) => ({ categoryId: completeValue.id, subCategoryId: null }),
  subCategoryId: (completeValue) => ({ subCategoryId: completeValue.id }),
  atachapterId: (completeValue) => ({ atachapterId: completeValue.id, atasectionId: null, ataparagraphId: null }),
  atasectionId: (completeValue) => ({ atasectionId: completeValue.id, ataparagraphId: null })
}

const GeneralSectionForm = ({ onChange, open, part, disabled }) => {

  const [values, setValues] = useState({ ...defaultEmptyValues });
  const [backup, setBackup] = useState(null);
  const [errorState, setErrorState] = useState({});
  // const [dropdownsData, setDrop downsData] = useState([]);
  const { hasPermission } = usePermissions();
  const [loadedPart, setLoadedPart] = useState(false);
  const [defaults, setDefaults] = useState({});
  const { successMsg, warningMsg, infoMsg } = useSnackBar();
  const [partBackup, setPartBackup] = useState(null);
  const { dropdownsData, setDropdownsData, setDropdownIds, dropdownDefaultOptions, updateRow, } = useContext(DropdownsContext);

  const dispatch = useDispatch();
  // const [defaults, setDefaults] = useState(null);

  useEffect(() => {
    if (open) {
      getPartInfo(part.id).then(response => {
        if (response.data.responseCode === 200) {
          let { id, partNumber, name, aviationPart, description, categoryId, subCategoryId, dimensionUomId, hazardousMaterial, receivingInspection, manufacturerId, pmaStatus } = response.data.load;
          setPartBackup(response.data.load);
          // let draftValues = JSON.parse(localStorage.getItem(`${localStoragePrefix}?id=${part.id}`) ?? "{}");
          let draftValues = localStorageGet(localStoragePrefix, { partId: part.id.toString() })[0];

          let form = {
            ...defaultEmptyValues,
            id,
            name,
            partNumber,
            description,
            categoryId,
            subCategoryId,
            pmaStatus,
            dimensionUomId,
            hazardousMaterial,
            manufacturerId,
            receivingInspection,
            atachapterId: aviationPart?.atachapterId ?? null,
            atasectionId: aviationPart?.atasectionId ?? null,
            ataparagraphId: aviationPart?.ataparagraphId ?? null
          };
          setDefaults({ ...form, ...draftValues });
          setValues({ ...form, ...draftValues });
          setBackup(form);
        }
      }
      ).catch(error => {
        console.error(error);
        let form = { ...defaultEmptyValues }
        setDefaults(form);
        setValues(form)
        setLoadedPart(false);
      });
    }
  }, [open, part]);

  useEffect(() => {
    // if (!disabled && (typeof (values.id) === 'number')) localStorage.setItem(`${localStoragePrefix}?id=${part.id}`, JSON.stringify(values));
    if (!disabled && (typeof (values.id) === 'number')) localStorageSave(localStoragePrefix, { partId: part.id }, { ...partBackup, ...values });
  }, [values]);

  const changeValue = (e) => {
    const { name, value, completeValue } = e.target;
    if (name in requiredFields) {
      setErrorState(prev => ({ ...prev, [name]: Boolean(value || completeValue) ? "" : "Required" }));
    }
    setValues(prev => {
      onChange?.({ name, value: completeValue ?? value }, { ...prev, [name]: value });
      return ({ ...prev, ...(fieldChangeMapper[name]?.(completeValue) ?? { [name]: value }) })
    });
    // updateValue(part.id, name, value);

  }

  useEffect(() => {
    // setDropdownIds([...otherDropdowns, ...ATADropdowns]);
    // if (open) {
    //   Promise.all([...otherDropdowns, ...ATADropdowns].map(id => getDropdownConfiguration(id))).then(response => {
    //     setDropdownsData(response.map(responseItem => responseItem.data.load))
    //   }
    //   );
    // }
  }, []);

  const handleDropdownValue = (value, name) => {
    changeValue({ target: { name, value: value.id, completeValue: value } });
    setDefaults(prev => ({ ...prev, ...(fieldChangeMapper[name]?.(value) ?? { [name]: ' ' }) }))
  }

  const updateDropdown = (dropdownId, parentValues, dependenciesToUpdate) => {
    setDropdownsData((prevDropdowns) =>
      prevDropdowns.map((filter) => {
        if (filter.id === dropdownId) {
          return {
            ...filter,
            parentValues,
            dependenciesToUpdate,
            reload: true,
          };
        }
        return filter;
      })
    );
  };

  const resetDropdownsReload = () => {
    setDropdownsData((filterState) => {
      if (filterState.length > 0) {
        return filterState.map((e) => {
          if (e.reload) {
            return { ...e, reload: false };
          }
          return e;
        });
      }
      return filterState;
    });
  };

  // const { saveDraft, removeDraft, resetPart, updateValue } = useContext(PartConfigurationContext);


  const openDraftPart = (partId, section, value) => {
    // saveDraft(partId, section, value);
    // dispatch(openDraft({ partId, sections: "configuration/parts/general" }));
  }

  const newParts = useSelector(selectNewParts);
  const cancelEdit = () => {

    dispatch(closeDraft({ partId: part.id, section: "general", additionalSections: ["row"] }));
    // removeDraft(part.id, 'general');
    if (part.id in newParts) infoMsg("Part Discarded", "Unsaved part was discarded");
    setValues(backup ?? defaultEmptyValues);
    setDefaults(backup ?? defaultEmptyValues);

    // resetPart(part.id);
  }


  const validateForm = () => {
    let errors = {};
    let count = 0;
    for (let k in requiredFields) {
      if (!Boolean(values[k])) {
        errors[k] = 'Required';
        count++;
      }
    }
    setErrorState(errors);
    return count === 0;
  }

  const saveSection = (disableForm) => {
    let isValid = validateForm();
    if (isValid) {
      infoMsg("Saving Part");
      let draft = localStorageGet(localStoragePrefix, { partId: part.id.toString() })[0] ?? partBackup;
      if (typeof (draft.atachapterId) === 'number') {
        let { atachapterId, atasectionId, ataparagraphId } = draft;
        draft.aviationPart = { ...(partBackup?.aviationPart ?? {}), atachapterId, atasectionId, ataparagraphId, companyId:( partBackup?.aviationPart?.companyId) ?? (partBackup?.companyId) ?? parseInt(localStorage.getItem("u_company_id"))};
      }
      createPart(draft).then(response => {
        if (response.data.responseCode < 300 && response.data.responseCode > 199) {
          successMsg('Part saved successfully');
          setValues({ ...defaultEmptyValues, ...response.data.load });
          setBackup({ ...defaultEmptyValues, ...response.data.load });
          // dispatch(confirmPart({ partId: part.id, section: "general", additionalSections: ["row"]}));
          if (disableForm) {
            dispatch(closeDraft({ partId: part.id, section: "general", additionalSections: ["row"]}))
          }
        } else {
          warningMsg("Something went wrong", (response.data.validationErrors?.length>0 ? `${response.data.validationErrors.map(e => e.error).join(', ')}` : '') || response.data.message || `${response.data.responseCode}`);
        }
      }).catch(error => {
        warningMsg(`Something went wrong`);
        console.error(`Error while saving part`, error);
      });
    } else {
      warningMsg("Incomplete Fields", "Please complete all required fields before saving.");
    }
  }

  const generalSectionButtons = [
    { label: 'Save and Finish', icon: "icon-save", id: 'save' },
    { label: 'Save and Continue Editing', icon: "icon-save", id: 'save-continue' },
    { label: 'Cancel', icon: "icon-cross", id: 'cancel', type: 'danger' }
  ];


  return (open &&
    <div className='general-section-form-wrapper' onKeyUp={(e)=>e.stopPropagation()} >
      <div className='section-header'>
        <div className='title-container'>
          <b>General Information</b>
          {disabled && hasPermission('update') && <button className='outlined iconTextButton small-size' onClick={() => openDraftPart(part.id, 'general', values)}>
            <i className='icon-edit'></i>
            <span>
              Edit
            </span>
          </button>}
        </div>
        {!disabled && hasPermission('update') && <MultioptionButton buttonCallbacks={{
          'save': () => saveSection(true),
          'save-continue': () => saveSection(false),
          'cancel': () => cancelEdit()
        }} buttons={generalSectionButtons} />}
      </div>
      <div className="general-section-form-component">
        {/* <input placeholder="*PN"></input> */}
        <Input upperCase error={errorState["partNumber"]} hideWhenDisabled disabled={disabled} maxLength="50" value={values["partNumber"]} name="partNumber" label={"PN"} required onChange={changeValue} />
        {<div className="general-info-ata" style={disabled ? { visibility: 'hidden', display: 'none' } : {}}>
          <b>ATA</b>
          <div>
            {
              dropdownsData.map(dropdownConfig => (
                ATADropdowns.includes(dropdownConfig.id) &&
                <Dropdowns
                  context={{ dropdownsData, setDropdownsData, setDropdownIds, dropdownDefaultOptions }}
                  updateDropdown={updateDropdown}
                  resetDropdownsReload={resetDropdownsReload}
                  disabled={disabled}
                  fixedLabel
                  key={dropdownConfig.id}
                  required={requiredDropdowns.includes(dropdownConfig.id)}
                  onOptionSelect={(value) => handleDropdownValue(value, dropdownNames[dropdownConfig.id])}
                  showPagination={false}
                  data={dropdownConfig}
                  preSelectValue={defaults?.[dropdownNames[dropdownConfig.id]]}
                  disableMaxWidth
                />

              ))
            }

          </div>
        </div>}
        <Input upperCase error={errorState["name"]} style={{ gridColumn: "span 2" }} disabled={disabled} required name="name" label={"Name"} value={values["name"]} onChange={changeValue} />
        <Input upperCase error={errorState["description"]} style={{ gridColumn: "span 2" }} hideWhenDisabled disabled={disabled} required name="description" label={"Long Part Description"} value={values["description"]} onChange={changeValue} />
        {
          dropdownsData.map(dropdownConfig => (
            otherDropdowns.includes(dropdownConfig.id) &&
            <Dropdowns
              context={{ dropdownsData, setDropdownsData, setDropdownIds, dropdownDefaultOptions }}
              updateDropdown={updateDropdown}
              resetDropdownsReload={resetDropdownsReload}
              hideWhenDisabled={hideFieldsWhenDisabled.has(dropdownNames[dropdownConfig.id])}
              disabled={disabled}
              key={dropdownConfig.id}
              required={requiredDropdowns.includes(dropdownConfig.id)}
              onOptionSelect={(value) => handleDropdownValue(value, dropdownNames[dropdownConfig.id])}
              showPagination={false}
              data={dropdownConfig}
              preSelectValue={defaults?.[dropdownNames[dropdownConfig.id]]}
              activateErrorHint={Boolean(errorState[[dropdownNames[dropdownConfig.id]]])}
              optionLabel={"name"}
            />
          ))
        }

        <div className='checkboxes'>


          <CheckboxField disabled={disabled} outlined checked={values["pmaStatus"]} onChange={(e) => changeValue({ target: { name: "pmaStatus", value: e } })}>
            <span>
              PMA
            </span>
          </CheckboxField>
          <CheckboxField disabled={disabled} outlined checked={values["hazardousMaterial"]} onChange={(e) => changeValue({ target: { name: "hazardousMaterial", value: e } })}>
            <div className='icon-checkbox'>
              <span>
                Hazardous Material
              </span>
              <span class="icon-coloredwarning"><span class="path1"></span><span class="path2"></span></span>
            </div>
          </CheckboxField>
          <CheckboxField disabled={disabled} outlined checked={values["receivingInspection"]} onChange={(e) => changeValue({ target: { name: "receivingInspection", value: e } })}>
            <span>
              Requires Inspection
            </span>
          </CheckboxField>
        </div>


      </div>
    </div>
  )
}

export default GeneralSectionForm;